module.exports = __webpack_public_path__ + "img/reply_active.7e70344f.svg";